export const isOrthodoxMode = process.env.REACT_APP_ORTHODOX_MODE === "true";
